import React, { useState } from 'react';
import { connect } from 'react-redux';

import { screen } from '$fcomponents/hoc';
import { Header, TableView2 } from '$gcomponents/widgets';

import USER_TABLE, { USER_TABLE_CONFIG } from './table';

import { IonPageWrapper } from './styles';
import PATH from '$gbusiness/enums/paths';
import FabButton from '$fcomponents/fabButton';
import FilterSection from '$gcomponents/widgets/tableView2/filterSection';
import StoreFilter from '$fcomponents/storeFilter';
import FactoryModel from '$fbusiness/models/factory';
import StoreModel from '$fbusiness/models/store';
import { accessHide, getAccess, isAccessible, isEnabled, updatedFilter } from '$fbusiness/helpers/util';
import CurrentStateModel from '$fbusiness/models/currentState';
import ItemActionModel from '$gbusiness/models/itemAction';
import { dialog } from '$gcomponents/reusables';
import { userActions } from '$fbusiness/redux/user';
interface StoresScreenProps {
  history: any;
  factory: FactoryModel;
  currentState: CurrentStateModel;
  stores: Array<StoreModel>;
  deleteUser: Function;
}

const UsersScreen: React.FC<StoresScreenProps> = ({ stores, deleteUser, currentState, factory }) => {
  const [filter, setFilter] = useState<any>({});
  const ACCESS = getAccess(currentState);

  const onChangeStore = (result) => {
    if (result) {
      setFilter({
        storeUser: !!result,
        storeId: result ? result.id : null,
      });
    } else {
      setFilter({});
    }
  };

  const userItemActions: Array<ItemActionModel> = [
    {
      label: 'BUTTON.DELETE',
      eventName: 'deleteItem',
      disabled: (row) => {
        return (
          !isAccessible(ACCESS.ACTION.USER.DELETE, currentState) ||
          row?.userLevel <= (currentState?.user?.userLevel || 0)
        );
      },
      onClick: (row) => {
        dialog.confirm({
          message: 'MESSAGE.DELETE_WARNING',
          onPress: async () => {
            await deleteUser(row.userId);
            setFilter(updatedFilter(filter, {}));
          },
        });
      },
    },
  ];

  const isStoreMode = filter?.storeId;
  const titleText = filter.storeUser
    ? isEnabled(factory.settings, 'storeToCustomer')
      ? 'Customer Users'
      : 'Store Users'
    : 'Factory Users';

  return (
    <IonPageWrapper>
      <Header titleText={titleText} />
      <TableView2
        TABLE={USER_TABLE}
        itemActions={userItemActions}
        filter={filter}
        tableConfig={USER_TABLE_CONFIG}>
        <FilterSection title={null}>
          <StoreFilter stores={stores} onChange={onChangeStore} />
        </FilterSection>
      </TableView2>
      <FabButton
        route={`${PATH.USERS}/0${isStoreMode ? `/${filter.storeId}` : ''}`}
        className={accessHide(isStoreMode ? ACCESS.ACTION.USER.CREATE : ACCESS.ACTION.USER.CREATE)}
      />
    </IonPageWrapper>
  );
};

const mapStateToProps = (state) => ({
  factory: state.factory.factory,
  stores: state.store.stores,
  resetOnRoute: true,
});

const mapDispatchToProps = {
  deleteUser: userActions.deleteUser,
};

const connected = connect(mapStateToProps, mapDispatchToProps);

export default connected(screen(UsersScreen));
